export class TeamService {
    static $inject = ['MessagingHubService', 'BlipService', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'DEFAULT_PAGE_SIZE'];
    constructor(MessagingHubService, BlipService, MESSAGINGHUBDOMAIN, BLIP_DOMAIN, DEFAULT_PAGE_SIZE) {
        this.MessagingHubService = MessagingHubService;
        this.BlipService = BlipService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    }
    /**
     * Add or update and attendant to an application
     * @param application
     * @param attendant
     */
    async set(attendants, userCulture = '') {
        const uri = '/attendants' + (userCulture.length > 0 ? `?userCulture=${userCulture}` : '');
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.lime.collection+json',
            uri: uri,
            resource: {
                total: attendants.length,
                itemType: 'application/vnd.iris.desk.attendant+json',
                items: attendants,
            },
        });
    }
    /**
     * Delete an application attendant
     * @param application
     * @param attendant
     */
    async delete(attendant) {
        await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/attendants/${encodeURIComponent(attendant.identity)}`,
        });
    }
    /**
     * Delete an application attendant delegation
     * @param application
     * @param attendant
     */
    async deleteDelegation(attendant) {
        await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `postmaster@${this.MESSAGINGHUBDOMAIN}`,
            uri: `/delegations/${encodeURIComponent(attendant.identity)}?envelopeTypes=command`,
        });
    }
    /**
     * Get application attendants
     * @param application
     * @param filters
     * @param skip
     * @param take
     */
    async getAttendants(filters, skip, take) {
        let filter = '';
        if (filters) {
            filter = `$filter=${encodeURIComponent(filters)}&`;
        }
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/attendants?${filter}$skip=${skip}&$take=${take}`,
        });
    }
    /**
     * Get application attendants queue
     * @param queueId
     * @param skip
     * @param take
     */
    async getAttendantsQueue(queueId, skip, take) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/attendants/queue/${encodeURIComponent(queueId)}?$skip=${skip}&$take=${take}`,
        });
    }
    /**
     * Filter application attendants queue
     * @param filter
     * @param queueId
     * @param skip
     * @param take
     */
    async filterAttendantsQueue(queueId, filter, skip, take) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/attendants/queue/${encodeURIComponent(queueId)}?$filter=(substringof('${encodeURIComponent(filter)}'%2CIdentity))&$skip=${skip}&$take=${take}`,
        });
    }
    async getAllAttendants(filters, pageSize = this.DEFAULT_PAGE_SIZE) {
        let count = 0;
        const attendants = [];
        while (true) {
            try {
                const { items } = await this.getAttendants(filters, count, pageSize);
                attendants.push(...items);
                count += pageSize;
                if (items.length < pageSize) {
                    break;
                }
            }
            catch (e) {
                break;
            }
        }
        return attendants;
    }
    /**
     * Get application teams
     * @param application
     */
    async getTeams(application) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/teams',
        });
    }
    /**
     * Get application teams
     * @param application
     */
    async getTeamsAndAgentsOnline(application) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/teams/agents-online',
        });
    }
    /**
     * Get attendant account using identiy name and domain
     * @param application
     * @param identity
     */
    async getAccount(identity) {
        const identitySplit = identity.split('@');
        const name = identitySplit[0];
        const domain = identitySplit[1] || this.BLIP_DOMAIN;
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@${domain}`,
            uri: `lime://${domain}/accounts/${encodeURIComponent(name)}`,
        }, 5000);
    }
    /**
     * Check if an attendant is online.
     * @param application
     * @param attendant
     */
    async getAttendantStatus(attendant) {
        try {
            await this.MessagingHubService.sendCommand({
                method: 'get',
                uri: '/ping',
                to: attendant.identity,
            });
            return 'online';
        }
        catch (e) {
            return 'offline';
        }
    }
    /**
     * Get contact using identiy name.
     * @param application
     * @param identity
     */
    async getContact(identity) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `/contacts/${encodeURIComponent(identity)}`,
            metadata: {
                'server.shouldStore': true,
            },
        });
    }
    async getAttendantsInContract(tenantId) {
        return this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            uri: `/tenants/${tenantId}/agents?skip=0&$take=999`,
        });
    }
}
TeamService.$inject = ['MessagingHubService', 'BlipService', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'DEFAULT_PAGE_SIZE'];
